export const BUTTON_TEXT = {
  addMeter: 'Add Meter',
  back: 'Back',
  cancel: 'Cancel',
  close: 'Close',
  confirmCancel: 'Yes',
  delete: 'Delete',
  download: 'Download',
  doNotCancel: 'No',
  goToAllocations: 'Allocation Settings',
  markReviewed: 'Mark Reviewed',
  save: 'Save',
  seeDetails: 'See Details',
  update: 'Update',
};
